// extracted by mini-css-extract-plugin
export default {"warn":"warn---vI9YN","success":"success---FBYW_"};